import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-common/src/async.tsx';
import {
	setPerformanceMarkLoadStart,
	setPerformanceMarkLoadEnd,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/performance-marks/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyInsightObjectSchemaSidebar = lazyForPaint(() => {
	setPerformanceMarkLoadStart();
	return import(/* webpackChunkName: "async-sidebar-insight-object-schema" */ './index').then(
		(bundle) => {
			setPerformanceMarkLoadEnd();
			return bundle;
		},
	);
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const InsightObjectSchemaSidebar = memo<Record<any, any>>(() => (
	<SidebarBoundary id="insight-object-schema-sidebar">
		<LazyInsightObjectSchemaSidebar />
	</SidebarBoundary>
));

InsightObjectSchemaSidebar.displayName = 'InsightObjectSchemaSidebar';

export default InsightObjectSchemaSidebar;
